import { Alert, Grid, Tab, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { PermissionsEnum } from "@/auth/interfaces";
import {
  a11yProps,
  calcOTImages,
  calcPreventaImages,
  hasPermission,
  // useLoaders,
  useTabsFormOnly,
} from "@/shared";
import ButtonGenerarDocumentos from "@/shared/components/erp/GenerarDocumentos/ButtonGenerarDocumentos";
import ButtonSubirDocumentosFirmados from "@/shared/components/erp/GenerarDocumentos/ButtonSubirDocumentosFirmados";
import {
  CustomTabPanel,
  FormTabsOnly,
  NestedTabsScene,
  PDFReader,
  TabTextLabel,
} from "@/shared/components/ui";
import { CustomAlertCard } from "@/shared/components/ui/Alerts";
import { ImageListModal, ImageModal } from "@/shared/components/ui/Images";
import { AlertSeverityEnum, Contrato, OrdenTrabajo } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { TabEnvioDocumentosAuditoriaInstall } from "../tab-auditoria-install.docs/TabEnvioDocumentosAuditoriaInstall";
import { TabSubirDocumentacionInstall } from "../tab-auditoria-install.docs/TabSubirDocumentoAuditoriaInstall";
import { useDocumentacionContratoStore } from "../../hooks/documentacion-contrato.store";

export type AuditoriaOTInstallDocsFormTabProps = {
  ordenTrabajo: OrdenTrabajo;
  contrato?: Contrato | null;
  /* documentos: {
    url_contrato: string;
    url_crokis: string;
    url_anexo_1: string;
    url_anexo_2: string;
  } */
};

const AuditoriaOTInstallDocsFormTab: React.FC<
  AuditoriaOTInstallDocsFormTabProps
> = ({ ordenTrabajo, contrato }) => {
  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 1,
  });

  const setDocumentos = useDocumentacionContratoStore((s) => s.setDocumentos);

  ///* local state ----------------------
  const [preventaImagesArr, setPreventaImagesArr] = useState<ImageModal[]>([]);
  const [ordenTrabajoImagesArr, setOrdenTrabajoImagesArr] = useState<
    ImageModal[]
  >([]);
  // const [isLoadingPreventaPhotos, setIsLoadingPreventaPhotos] = useState(true);

  const [valueTabDocs, setValueTabDocs] = useState(1);
  const handleMethodChangeDocsTab = (_event: any, newValue: number) => {
    setValueTabDocs(newValue);
  };

  ///* global state ----------------------
  const setAlert = useUiStore((s) => s.setAlert);

  ///* effects ----------------------
  useEffect(() => {
    if (!ordenTrabajo) return;

    const totalImagesOT = [
      ...calcOTImages(ordenTrabajo, "urls_fotos_entrada"),
      ...calcOTImages(ordenTrabajo, "urls_fotos_salida"),
    ];
    if (!totalImagesOT?.length) {
      setAlert(
        true,
        "Todavía no se han cargado las fotos de ingreso y salida de instalación",
        AlertSeverityEnum.warning,
      );
    }
    setOrdenTrabajoImagesArr(totalImagesOT);

    setDocumentos(contrato?.documentacion_data ?? []);

    (async () => {
      const imagesArr = await calcPreventaImages(ordenTrabajo?.preventa_data!);

      setPreventaImagesArr(imagesArr);
      // setIsLoadingPreventaPhotos(false);
    })();
  }, [ordenTrabajo]);

  // useLoaders(isLoadingPreventaPhotos);

  return (
    <>
      {/* ================== DOCS ================== */}
      <TabTextLabel text="DOCUMENTOS" pb="24px" pt="12px" />
      <Typography variant="h6">
        Tipo de Contrato: {ordenTrabajo?.contrato_data?.tipo_contrato}
      </Typography>
      <Grid container item spacing={2}>
        {hasPermission(PermissionsEnum.api_enable_generate_documents) ? (
          <>
            <Grid item>
              <ButtonGenerarDocumentos
                ordenTrabajoId={ordenTrabajo.id_orden_trabajo}
                enableReload={true}
                signatureInDocs={true}
                generateContract={true}
                preventaId={ordenTrabajo?.preventa_data?.id_preventa}
              />
            </Grid>
            <Grid item>
              <ButtonSubirDocumentosFirmados
                preventaId={ordenTrabajo?.preventa_data?.id_preventa}
                ordenTrabajoId={ordenTrabajo.id_orden_trabajo}
                noTramite={ordenTrabajo?.preventa_data?.no_tramite_firma}
                enableReload={true}
              />
            </Grid>
          </>
        ) : null}
      </Grid>
      <NestedTabsScene
        tabs={
          <FormTabsOnly
            onChange={handleMethodChangeDocsTab}
            value={valueTabDocs}
          >
            <Tab label="CONTRATO" value={1} {...a11yProps(1)} />
            <Tab label="ANEXO 1F" value={2} {...a11yProps(2)} />
            {ordenTrabajo?.contrato_data?.url_anexo_2_f && (
              <Tab label="ANEXO 2F" value={3} {...a11yProps(3)} />
            )}
            {ordenTrabajo?.contrato_data?.url_anexo_1_orden && (
              <Tab label="ORDEN DE SERVICIO" value={4} {...a11yProps(4)} />
            )}
            {/* <Tab label="ANEXO TÉCNICO" value={4} {...a11yProps(4)} /> */}
            {/* <Tab label="CROQUIS" value={4} {...a11yProps(4)} /> */}
            {/* <Tab label="ORDEN TRABAJO" value={5} {...a11yProps(5)} /> */}
            {<Tab label="AUTORIZACIÓN BURÓ" value={6} {...a11yProps(6)} />}
            {(ordenTrabajo?.preventa_data?.url_autorizacion_debito_automatico ||
              ordenTrabajo?.preventa_data?.url_autorizacion_cargo_tarjeta) && (
              <Tab label="FORMA DE PAGO" value={7} {...a11yProps(7)} />
            )}
            {hasPermission(PermissionsEnum.contrato_cargar_documentos) && (
              <Tab label="SUBIR DOCUMENTO" value={9} {...a11yProps(9)} />
            )}
            {hasPermission(
              PermissionsEnum.contrato_enviar_documento_consolidado,
            ) && (
              <Tab label="ENVÍO DE DOCUMENTOS" value={10} {...a11yProps(10)} />
            )}
          </FormTabsOnly>
        }
      >
        {hasPermission(PermissionsEnum.contrato_cargar_documentos) && (
          <CustomTabPanel index={valueTabDocs} value={9}>
            {contrato ? (
              <TabSubirDocumentacionInstall contrato={contrato} />
            ) : (
              <Alert variant="outlined" severity="warning">
                No existe contrato
              </Alert>
            )}
          </CustomTabPanel>
        )}

        {hasPermission(
          PermissionsEnum.contrato_enviar_documento_consolidado,
        ) && (
          <CustomTabPanel index={valueTabDocs} value={10}>
            {contrato ? (
              <TabEnvioDocumentosAuditoriaInstall contrato={contrato} />
            ) : (
              <Alert variant="outlined" severity="warning">
                No existe contrato
              </Alert>
            )}
          </CustomTabPanel>
        )}

        <CustomTabPanel index={valueTabDocs} value={1}>
          <PDFReader
            fileUrl={
              `${
                ordenTrabajo?.contrato_data?.url_contrato
              }?v=${new Date().getTime()}` || ""
            }
          />
        </CustomTabPanel>

        <CustomTabPanel index={valueTabDocs} value={2}>
          <PDFReader
            fileUrl={
              `${
                ordenTrabajo?.contrato_data?.url_anexo_1_f
              }?v=${new Date().getTime()}` || ""
            }
          />
        </CustomTabPanel>

        <CustomTabPanel index={valueTabDocs} value={3}>
          <PDFReader
            fileUrl={
              `${
                ordenTrabajo?.contrato_data?.url_anexo_2_f
              }?v=${new Date().getTime()}` || ""
            }
          />
        </CustomTabPanel>

        <CustomTabPanel index={valueTabDocs} value={4}>
          <PDFReader
            fileUrl={
              `${
                ordenTrabajo?.contrato_data?.url_anexo_1_orden
              }?v=${new Date().getTime()}` || ""
            }
          />
        </CustomTabPanel>

        {/* <CustomTabPanel index={valueTabDocs} value={4}>
            <PDFReader
              fileUrl={ordenTrabajo?.contrato_data?.url_anexo_1_tec || ''}
            />
          </CustomTabPanel> */}

        {/* <CustomTabPanel index={valueTabDocs} value={4}>
            <PDFReader
              fileUrl={ordenTrabajo?.contrato_data?.url_crokis || ''}
            />
          </CustomTabPanel> */}

        {/* <CustomTabPanel index={valueTabDocs} value={5}>
            <PDFReader
              fileUrl={ordenTrabajo?.url_orden_trabajo || ''}
            />
          </CustomTabPanel> */}

        <CustomTabPanel index={valueTabDocs} value={6}>
          {ordenTrabajo?.contrato_data?.url_autorizacion_buro ? (
            <PDFReader
              fileUrl={
                `${
                  ordenTrabajo?.contrato_data?.url_autorizacion_buro
                }?v=${new Date().getTime()}` || ""
              }
            />
          ) : (
            <Typography>Documento no generado</Typography>
          )}
        </CustomTabPanel>

        {(ordenTrabajo?.preventa_data?.url_autorizacion_debito_automatico ||
          ordenTrabajo?.preventa_data?.url_autorizacion_cargo_tarjeta) && (
          <CustomTabPanel index={valueTabDocs} value={7}>
            {ordenTrabajo?.preventa_data?.url_autorizacion_debito_automatico ? (
              <PDFReader
                fileUrl={
                  `${ordenTrabajo?.preventa_data?.url_autorizacion_debito_automatico}?v=${new Date().getTime()}` ||
                  ""
                }
              />
            ) : ordenTrabajo?.preventa_data?.url_autorizacion_cargo_tarjeta ? (
              <PDFReader
                fileUrl={
                  `${ordenTrabajo?.preventa_data?.url_autorizacion_cargo_tarjeta}?v=${new Date().getTime()}` ||
                  ""
                }
              />
            ) : (
              <Typography>Documento no generado</Typography>
            )}
          </CustomTabPanel>
        )}
      </NestedTabsScene>

      {/* ================== PHOTOS ================== */}
      <TabTextLabel text="Fotos" pt="54px" pb="0px" />
      <NestedTabsScene
        tabs={
          <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
            <Tab label="ORDEN TRABAJO" value={1} {...a11yProps(1)} />
            <Tab label="PREVENTA" value={2} {...a11yProps(2)} />
          </FormTabsOnly>
        }
      >
        <CustomTabPanel index={valueTab} value={1}>
          {ordenTrabajoImagesArr?.length ? (
            <ImageListModal images={ordenTrabajoImagesArr || []} />
          ) : (
            <CustomAlertCard
              alertTitle="ALERTA"
              alertMessage="Todavía no se han cargado las fotos de ingreso y salida de instalación"
            />
          )}
        </CustomTabPanel>

        <CustomTabPanel index={valueTab} value={2}>
          <ImageListModal images={preventaImagesArr || []} />
        </CustomTabPanel>
      </NestedTabsScene>
    </>
  );
};

export default AuditoriaOTInstallDocsFormTab;
